import React, {Component} from 'react';
import {connect} from 'react-redux';
import MyCheckbox from '../layout/Checkbox';
import Collapsible from '../layout/Collapsible';
import { searchAction } from '../../store/actions/searchActions';
import {
    toggleModalAction,
    addPeriodicalIndexAction,
    removePeriodicalIndexAction,
    addPeriodicalIndexesAction,
    removePeriodicalIndexesAction,
    addYearAction,
    removeYearAction,
    addMonthAction,
    removeMonthAction,
} from '../../store/actions/filtersActions';

const range = (start, end) => Array.from({length: (end - start + 1)}, (v, k) => k + start);

const FULL_MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const ABBR_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const NUMERIC_MONTHS = ['1','2','3','4','5','6','7','8','9','10','11','12'];
const BIMONTHLY_MONTHS = ['1-2','3-4','5-6','7-8','9-10','11-12'];

// All 9 periodicals with year/month metadata
const PERIODICAL_INDEXES = [
    { id: 'new_alfazal', label: 'Al-Fazal', years: range(1913, 1971), hasMonths: true, months: FULL_MONTHS },
    { id: 'review_of_religions', label: 'Review of Religions', years: [...range(1902, 1946), ...range(1961, 1982)], hasMonths: false, months: [] },
    { id: 'alhakam', label: 'Al-Hakam', years: range(1897, 1920), hasMonths: true, months: ABBR_MONTHS },
    { id: 'albadar', label: 'Al-Badar', years: range(1902, 1913), hasMonths: false, months: [] },
    { id: 'muslim_sunrise', label: 'Muslim Sunrise', years: range(1921, 2024), hasMonths: false, months: [] },
    { id: 'ak_diaries', label: "AK's Diary", years: [], hasMonths: false, months: [] },
    { id: 'al-rehmat', label: 'Al-Rehmat', years: range(1949, 1950), hasMonths: true, months: NUMERIC_MONTHS },
    { id: 'al-furqan', label: 'Al-Furqan', years: range(1954, 1974), hasMonths: true, months: NUMERIC_MONTHS },
    { id: 'tasheez-ul-azhan', label: 'Tasheez-ul-Azhan', years: range(1906, 1920), hasMonths: true, months: BIMONTHLY_MONTHS },
];

class NamePeriodicalsFilters extends Component{

    constructor(props){
        super(props)
        this.applyFilters = this.applyFilters.bind(this)
        this.handleIndexCheckbox = this.handleIndexCheckbox.bind(this)
        this.selectAllIndexes = this.selectAllIndexes.bind(this)
        this.handleYearCheckbox = this.handleYearCheckbox.bind(this)
        this.handleMonthCheckbox = this.handleMonthCheckbox.bind(this)
        this.selectAllYearsForPeriodical = this.selectAllYearsForPeriodical.bind(this)
    }

    selectAllIndexes(e){
        if(e.target.checked){
            this.props.addPeriodicalIndexes(PERIODICAL_INDEXES.map(idx => idx.id))
        }
        else{
            this.props.removePeriodicalIndexes()
        }
    }

    handleIndexCheckbox(e){
        const indexId = e.target.id.split('periodical-index-')[1]
        if(e.target.checked){
            this.props.addPeriodicalIndex(indexId)
        }
        else{
            // When unchecking a periodical, also remove its years and months from selections
            const periodical = PERIODICAL_INDEXES.find(p => p.id === indexId)
            if (periodical) {
                const currentYears = this.props.filters.years || [];
                const currentMonths = this.props.filters.months || [];
                periodical.years.forEach(y => {
                    if (currentYears.includes(y)) {
                        this.props.removeYear(y)
                    }
                })
                periodical.months.forEach(m => {
                    if (currentMonths.includes(m)) {
                        this.props.removeMonth(m)
                    }
                })
            }
            this.props.removePeriodicalIndex(indexId)
        }
    }

    selectAllYearsForPeriodical(periodical, e){
        const currentYears = this.props.filters.years || [];
        if(e.target.checked){
            // Add only years not already selected
            periodical.years.forEach(y => {
                if (!currentYears.includes(y)) {
                    this.props.addYear(y)
                }
            })
        }
        else{
            // Remove only this periodical's years
            periodical.years.forEach(y => {
                if (currentYears.includes(y)) {
                    this.props.removeYear(y)
                }
            })
        }
    }

    handleYearCheckbox(e){
        const year = parseInt(e.target.id.split('year-')[1])
        if(e.target.checked){
            this.props.addYear(year)
        }
        else{
            this.props.removeYear(year)
        }
    }

    handleMonthCheckbox(e){
        const month = e.target.id.split('month-')[1]
        if(e.target.checked){
            this.props.addMonth(month)
        }
        else{
            this.props.removeMonth(month)
        }
    }

    applyFilters(){
        this.props.perfromSearch( document.querySelector("#search_field").value,
                                    this.props.filters )
        this.props.toggleModal(false)
    }

    renderPeriodicalFilters(periodical){
        const years = this.props.filters.years || [];
        const months = this.props.filters.months || [];
        const allYearsSelected = periodical.years.length > 0 && periodical.years.every(y => years.includes(y));

        return (
            <Collapsible
                key={periodical.id + '-filters'}
                defaultExpanded={false}
                header={periodical.label + ' Filters'}
                body={
                    <div>
                        {periodical.years.length > 0 && (
                            <div style={{marginBottom: '10px'}}>
                                <strong>Years</strong>&nbsp;
                                <MyCheckbox
                                    checked={allYearsSelected}
                                    onChange={(e) => this.selectAllYearsForPeriodical(periodical, e)}
                                    label="Select all"
                                    id={periodical.id + '-select-all-years'}
                                />
                                <div className="filters-flex" style={{flexWrap: 'wrap'}}>
                                    {periodical.years.map(year => (
                                        <div key={year} className="width-content margin-left-40p">
                                            <MyCheckbox
                                                checked={years.includes(year)}
                                                onChange={this.handleYearCheckbox}
                                                label={String(year)}
                                                id={periodical.id + '-year-' + year}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                        {periodical.hasMonths && (
                            <div style={{marginTop: '10px'}}>
                                <strong>Months</strong>
                                <div className="filters-flex" style={{flexWrap: 'wrap'}}>
                                    {periodical.months.map(month => (
                                        <div key={month} className="width-content margin-left-40p">
                                            <MyCheckbox
                                                checked={months.includes(month)}
                                                onChange={this.handleMonthCheckbox}
                                                label={month}
                                                id={periodical.id + '-month-' + month}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                }
            />
        )
    }

    render(){
        const periodicalIndexes = this.props.filters.periodicalIndexes || [];
        const years = this.props.filters.years || [];
        const months = this.props.filters.months || [];
        const allSelected = periodicalIndexes.length === PERIODICAL_INDEXES.length;
        const selectedPeriodicals = PERIODICAL_INDEXES.filter(
            p => periodicalIndexes.includes(p.id) && (p.years.length > 0 || p.hasMonths)
        );

        return <div className="">
            <span><strong>Select Periodicals</strong></span>&nbsp;
            <MyCheckbox
                checked={allSelected}
                onChange={this.selectAllIndexes}
                label={"Select all"}
            />
            <div className="display-flex" style={{flexWrap: 'wrap'}}>
                {PERIODICAL_INDEXES.map(index => {
                    return <div
                            key={index.id}
                            className="width-content margin-left-40p"
                            style={{minWidth: '200px'}}
                            >
                                <MyCheckbox
                                checked={periodicalIndexes.includes(index.id)}
                                onChange={this.handleIndexCheckbox}
                                label={index.label}
                                id={"periodical-index-" + index.id}/>
                            </div>
                })}
            </div>

            {selectedPeriodicals.length > 0 && (
                <div style={{marginTop: '15px'}}>
                    {selectedPeriodicals.map(p => this.renderPeriodicalFilters(p))}
                </div>
            )}

            <div className="apply-filters-container">
                <button onClick={this.applyFilters} className="btn apply-filters-btn margin-auto display-block">Apply and Search</button>
            </div>
        </div>
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        perfromSearch: (term, filters) => dispatch(searchAction(term, 0, filters)),
        toggleModal: value => dispatch(toggleModalAction(value)),
        addPeriodicalIndex: index => dispatch(addPeriodicalIndexAction(index)),
        removePeriodicalIndex: index => dispatch(removePeriodicalIndexAction(index)),
        addPeriodicalIndexes: indexes => dispatch(addPeriodicalIndexesAction(indexes)),
        removePeriodicalIndexes: () => dispatch(removePeriodicalIndexesAction()),
        addYear: year => dispatch(addYearAction(year)),
        removeYear: year => dispatch(removeYearAction(year)),
        addMonth: month => dispatch(addMonthAction(month)),
        removeMonth: month => dispatch(removeMonthAction(month)),
    }
}

const mapStateToProps = (state) => {
    return {
        filters: state.filters,
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NamePeriodicalsFilters)
